import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { infoAlert } from 'src/store/actions/alertActions';
import { DashboardLayout } from 'src/skins/mars/components/layouts';
import { Spinner } from 'src/skins/common/components';
import { Icon } from 'src/skins/common/icon';
import { getUserWallet, gotoYawo } from 'src/store/actions/userActions';
import { formatCurrency, copyToClipboard } from 'src/utils';
import Banner from 'src/skins/common/components/Banner';
import { ConfirmActionModal } from 'src/skins/mars/modals';

import VerifiedMarkIcon from 'src/assets/svgs/icon-verified-mark.svg';
import UserIcon from 'src/assets/svgs/icon-user.svg';
import IconTransfer from 'src/skins/mars/assets/svgs/icon-transfer.svg';
import IconBills from 'src/skins/mars/assets/svgs/icon-bills.svg';
// import IconInsurance from 'src/skins/mars/assets/svgs/icon-insurance.svg';
import IconWithdraw from 'src/skins/mars/assets/svgs/icon-withdraw.svg';
import IconShop from 'src/skins/mars/assets/svgs/icon-shop.svg';
import YawoLogo from 'src/skins/mars/assets/svgs/yawo-logo.svg';

const Wrapper = styled.div`
  .header-wrapper {
    margin-bottom: 1rem;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.25rem;
    margin-top: 0.5rem;

    img {
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  .hi-username {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    h2 {
      font-size: 1.1rem;
    }

    img {
      width: 1rem;
      height: 1rem;
      margin-left: 0.75rem;
    }
  }

  .transfer_id {
    display: flex;
    grid-gap: 0.5rem;
    justify-content: space-between;

    & > div {
      display: flex;
      grid-gap: 0.5rem;
      cursor: pointer;
      align-items: center;
    }
  }

  .transfer-id {
    font-size: 0.9rem;
    font-weight: 400;
  }

  .available-balance--wrapper {
    position: relative;
    margin-top: 2rem;
    background-color: #0d0d0d;
    color: #ffffff;
    padding: 1.5rem;
    border-radius: 24px;

    & > div {
      position: relative;
    }
  }

  .available-balance--toggle {
    position: absolute;
    top: -1rem;
    right: 0;
    appearance: none;
    outline: none;
    border: 0;
    color: rgba(255, 255, 255, 0.55);
    background: transparent;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 8px;
    padding: 0.75rem;
  }

  .available-balance {
    background: transparent;

    .title {
      color: rgba(255, 255, 255, 0.55);
      font-size: 0.9rem;
    }

    .balance {
      margin-top: 0.5rem;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }

  section {
    margin: 1rem 0;
  }

  .dashboard-actions {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;

    & a {
      display: flex;
      padding: 1rem;
      background: #f5f5f7;
      color: #000000;
      border: 0;
      outline: none;
      text-decoration: none;
      min-width: 35%;

      & > div {
        border-radius: 8px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      }

      &:focus {
        & > div {
          box-shadow: none;
        }
      }

      img {
        height: 2rem;
        display: inline-block;
      }
    }

    .action-card {
      display: flex;
      align-items: center;
      height: 5rem;
      padding: 1rem;
      font-size: 0.9rem;
      font-weight: 600;
      border-radius: 8px;

      &:focus,
      &:hover {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.09);
      }

      & > span:first-child {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 3rem;
        height: 3rem;
        background: #ffffff;
        border-radius: 8px;
        margin-right: 0.5rem;
      }
    }
  }

  .soon {
    padding-left: 0.2rem;
    font-size: 0.5rem;
  }
`;

const Dashboard = () => {
  const [showAvailableBalance, setShowAvailableBalance] = useState(false);
  const toggleAvailableBalance = () => setShowAvailableBalance(!showAvailableBalance);

  const mmo = useSelector(state => state.MMO.mmo);
  const mmoServices = mmo.services ? mmo.services.split(';') : [];
  const { user, wallet, isLoading } = useSelector(state => state.USER);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // PREVENT refetching the user wallet when Dashboard is used as a backgroundPage
    if (history.location.pathname === '/dashboard') {
      dispatch(getUserWallet());
    }
  }, [getUserWallet]);

  const copiedAlert = value => dispatch(infoAlert('Copied: ' + value));

  const [showConfirmToOpenYawoAppModal, setConfirmToOpenYawoAppModal] = useState(false);
  const openConfirmToOpenYawoAppModal = () => setConfirmToOpenYawoAppModal(true);
  const closeConfirmToOpenYawoAppModal = () => setConfirmToOpenYawoAppModal(false);
  const acceptToOpenYawoApp = () => gotoYawo(closeConfirmToOpenYawoAppModal);

  return (
    <DashboardLayout light>
      <Wrapper>
        <div className="header-wrapper">
          <div className="header">
            <div>
              <h4>Welcome home,</h4>
            </div>
            <img src={UserIcon} alt="USER" />
          </div>

          <div className="transfer_id">
            <div>
              <p className="transfer-id">Transfer ID: {user.iuwi}</p>
              <Icon name="copy" size="small" onClick={() => copyToClipboard('transferId', copiedAlert)} />
            </div>
            {isLoading.getUserWallet && <Spinner theme="primary" />}
          </div>

          <input id="transferId" type="text" value={user.iuwi} onChange={null} readOnly style={hiddenInputStyle} />

          <div className="available-balance--wrapper">
            <div className="hi-username">
              <h2>Hi {`${user.firstName} ${user.lastName}`},</h2>
              <img src={VerifiedMarkIcon} alt="✔" />
            </div>

            <div>
              <button type="button" className="available-balance--toggle" onClick={toggleAvailableBalance}>
                <Icon size="small" name={showAvailableBalance ? 'eye' : 'eyeOff'} />
              </button>
              <div className="available-balance">
                <div className="title">Available Balance</div>
                <div className="balance">
                  {!isLoading.getUserWallet
                    ? showAvailableBalance
                      ? formatCurrency(wallet.walletBalance || 0, 'NGN')
                      : '********'
                    : '•••'}
                </div>
              </div>
            </div>
          </div>
        </div>

        {!user.hasPin && (
          <Banner type="warning">
            <p>
              {'Transaction pin not set. '}
              <span className="link" onClick={() => history.push('/dashboard/settings')}>
                Click Here
              </span>
            </p>
          </Banner>
        )}

        <section>
          <div className="dashboard-actions">
            <Link to="/dashboard/transfer" className="action-card">
              <span>
                <img src={IconTransfer} alt="..." />
              </span>
              Transfer
            </Link>
            <Link to="/dashboard/bills" className="action-card">
              <span>
                <img src={IconBills} alt="..." />
              </span>
              Bills payment
            </Link>
            <Link to="/dashboard/support" className="action-card">
              <span>
                <img src={IconShop} alt="..." />
              </span>
              Issues
            </Link>
            {mmoServices.some(x => x === 'clec') && (
              <Link to="/dashboard/collections" className="action-card">
                <span>
                  <img src={IconWithdraw} alt="..." />
                </span>
                Collections
              </Link>
            )}
            <Link to="/dashboard/devices" className="action-card">
              <span>
                <img src={IconTransfer} alt="..." />
              </span>
              My Devices
            </Link>
            {mmoServices.some(x => x === 'yawo') && (
              <>
                <Link to="#" onClick={openConfirmToOpenYawoAppModal} className="action-card">
                  <span>
                    <img src={YawoLogo} alt="..." />
                  </span>
                  Yawo
                </Link>
                <ConfirmActionModal
                  isOpen={showConfirmToOpenYawoAppModal}
                  actionTitle="Confirm To Access Yawo"
                  actionMessage="This action takes you to Yawo App"
                  onAccept={acceptToOpenYawoApp}
                  onDecline={closeConfirmToOpenYawoAppModal}
                  closeModal={closeConfirmToOpenYawoAppModal}
                />
              </>
            )}
            <Link to="/dashboard/withdrawal/third-party" className="action-card">
              <span>
                <img src={IconTransfer} alt="..." />
              </span>
              Cardless Withdrawal
            </Link>
            {/* <Link
							to="/dashboard"
							className="action-card"
							onClick={() => dispatch(infoAlert('Coming Soon'))}
						>
							<span><img src={IconWithdraw} alt="..." /></span>
							Cash
						</Link> */}
            {/* <Link
							to="/dashboard"
							className="action-card"
							onClick={() => dispatch(infoAlert('Coming Soon'))}
						>
							<span><img src={IconInsurance} alt="..." /></span>
							Insurance
						</Link> */}
            {/* <Link
							to="/dashboard"
							className="action-card"
							onClick={() => dispatch(infoAlert('Coming Soon'))}
						>
							<span><img src={IconShop} alt="..." /></span>
							Shop
						</Link> */}
            <span style={{ width: '1rem' }} serving-as-space="">
              &nbsp;
            </span>
          </div>
        </section>
      </Wrapper>
    </DashboardLayout>
  );
};

const hiddenInputStyle = { opacity: 0, display: 'block', marginBottom: '-2rem' };

export default Dashboard;
